document.addEventListener('DOMContentLoaded', function () {
  // home tabs //
  let homeTabs = document.querySelectorAll('.home-tab');

  homeTabs.forEach(function (homeTab, index) {
    let link = homeTab.querySelector('.link-area');
    let backdrop = homeTab.querySelector('.backdrop');
    let container = homeTab.parentElement;
    let mouseoverTimer;
    let windowWidth = window.innerWidth;
    let canCloseTab = true;
    let isTabOpen = false;

    if (windowWidth >= 768) {
      desktopTabs();
    } else {
      //mobileTabs();
    }

    window.addEventListener('resize', function () {
      windowWidth = window.innerWidth;
      if (windowWidth >= 768) {
        desktopTabs();
      } else {
        removeDesktopTabsEvents();
        //mobileTabs();
      }
    });

    function mobileTabs() {
      homeTab.addEventListener('click', function (e) {
        if (!homeTab.classList.contains('basis-2/3')) {
          if ((e.target = link)) {
            e.preventDefault();
          }
        }
        homeTabs.forEach(function (otherHomeTabs) {
          let otherBackdrops = otherHomeTabs.querySelector('.backdrop');
          let otherLinks = otherHomeTabs.querySelector('.link-area');
          otherBackdrops.classList.add('opacity-0');
          otherLinks.classList.add('opacity-0');
          otherHomeTabs.classList.add('basis-1/6');
          otherHomeTabs.classList.remove('basis-2/3');
        });
        backdrop.classList.remove('opacity-0');
        link.classList.remove('opacity-0');
        homeTab.classList.add('basis-2/3');
        homeTab.classList.remove('basis-1/6');
      });
    }
    function desktopTabs() {
      link.addEventListener('mouseover', onLinkMouseOver);
      link.addEventListener('mouseleave', onLinkMouseLeave);
    }
    function removeDesktopTabsEvents() {
      link.removeEventListener('mouseover', onLinkMouseOver);
      link.removeEventListener('mouseleave', onLinkMouseLeave);
    }
    function onLinkMouseOver() {
      clearTimeout(mouseoverTimer);
      mouseoverTimer = setTimeout(function () {
        //homeTab.classList.remove('md:basis-[calc(calc(100%-.5rem)/3)]');
        isTabOpen = true;
        homeTab.classList.add('md:!basis-full');
        if (index == 0) {
          container.classList.add('justify-start');
          container.classList.remove('justify-center', 'justify-end');
        } else if (index == 1) {
          container.classList.add('justify-center');
          container.classList.remove('justify-start', 'justify-end');
        } else if (index == 2) {
          container.classList.add('justify-end');
          container.classList.remove('justify-start', 'justify-center');
        }
      }, 500);
    }
    function onLinkMouseLeave() {
      clearTimeout(mouseoverTimer);
      isTabOpen = false;
      if (canCloseTab) {
        homeTab.classList.remove('md:!basis-full');
        //homeTab.classList.add('md:basis-[calc(calc(100%-.5rem)/3)]');
        setTimeout(function () {
          container.classList.add('justify-center');
          container.classList.remove('justify-start', 'justify-end');
        }, 500);
      }
    }
    // halt hover events till tab opening transition ends
    homeTab.addEventListener('transitionstart', function (event) {
      if (event.propertyName !== 'flex-basis') return;
      if (isTabOpen) canCloseTab = false;
    });
    homeTab.addEventListener('transitionend', function (event) {
      if (event.propertyName !== 'flex-basis') return;
      if (!isTabOpen && !canCloseTab) {
        canCloseTab = true;
        onLinkMouseLeave();
      }
      canCloseTab = true;
    });
  });

  // announcement ticker script //

  let announcementBarSwiper = new Swiper('.swiper.announcement-bar-swiper', {
    slidesPerView: 1,
    centeredSlides: true,
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 700,
  });

  // header script //

  let lastScrollTop = window.scrollY || document.documentElement.scrollTop;
  let headerNav = document.querySelector('header');
  // optimize scroll event execution
  let headerHidden = lastScrollTop > 0;
  let isScrolling = false;
  //let scrollTimeout;

  //headerNav.classList.add('!top-0');

  document.addEventListener('scroll', toggleHeader, false);

  function toggleHeader(e) {
    let st = window.scrollY || document.documentElement.scrollTop;
    // scroll event optimization [start]
    /* clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      isScrolling = false;
    }, 500); */
    if (isScrolling) {
      lastScrollTop = st <= 0 ? 0 : st;
      return;
    }
    isScrolling = true;
    setTimeout(() => {
      isScrolling = false;
    }, 1000);
    // scroll event optimization [end]
    if (!headerHidden && st > lastScrollTop) {
      headerNav.classList.remove('!top-0');
      headerHidden = true;
    } else if (headerHidden && st < lastScrollTop) {
      headerNav.classList.add('!top-0');
      headerHidden = false;
    } // else was horizontal scroll
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  }

  // luxury siwper scripts //

  const productSwiper = new Swiper('.swiper.product-swiper', {
    slidesPerView: 2,
    spaceBetween: 8,
    freeMode: true,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 3,
        //spaceBetween: 32,
      },
      1024: {
        slidesPerView: 5,
        //spaceBetween: 64,
      },
      1536: {
        slidesPerView: 5.5,
      },
    },
    navigation: {
      nextEl: '.button-next',
      prevEl: '.button-prev',
    },
  });

  // luxury single swiper scripts //
  var luxuryPackagingThumbs = new Swiper('.swiper.luxury-packaging-thumbs', {
    slidesPerView: 'auto',
    direction: 'vertical',
    watchSlidesProgress: true,
    autoHeight: true,
    resistanceRatio: 0,
    spaceBetween: 12,
    on: {
      click() {
        luxuryPackagingThumbs.slideTo(this.clickedIndex);
      },
    },
  });

  var luxuryPackagingSwiper = new Swiper('.swiper.luxury-packaging-swiper', {
    direction: 'vertical',
    autoHeight: true,
    resistanceRatio: 0,
    spaceBetween: 12,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: luxuryPackagingThumbs,
    },
  });

  // shop product swiper scripts //
  var shopProductThumbs = new Swiper('.swiper.shop-product-thumbs', {
    slidesPerView: 'auto',
    watchSlidesProgress: true,
    autoHeight: true,
    resistanceRatio: 0,
    spaceBetween: 12,
    on: {
      click() {
        shopProductThumbs.slideTo(this.clickedIndex);
      },
    },
  });

  var shopProductSwiper = new Swiper('.swiper.shop-product-swiper', {
    autoHeight: true,
    resistanceRatio: 0,
    spaceBetween: 12,
    slidesPerView: 1,
    thumbs: {
      swiper: shopProductThumbs,
    },
  });
  // event listener to update slider on product variant change
  document.body.addEventListener('ProductVariantUpdate', (event) => {
    if (event.detail === undefined || event.detail.variant === undefined) return;
    const variantId = event.detail.variant.value;
    if (!variantId) return;

    const selectedSlide = shopProductSwiper.slides.findIndex(
      (slide) => slide.dataset.hasOwnProperty('image_variants') && slide.dataset.image_variants.includes(variantId)
    );
    if (selectedSlide == -1) return;
    shopProductSwiper.slideTo(selectedSlide);
  });

  let accordions = document.querySelectorAll('.accordion');

  accordions.forEach(function (accordion) {
    let animatingAccordion = false;
    let header = accordion.querySelector('.accordion-header');
    let content = accordion.querySelector('.accordion-content');
    let plusIcon = header.querySelector('.plus-icon');
    let minusIcon = header.querySelector('.minus-icon');
    // store accordion image in case it exists
    const image = accordion.dataset.hasOwnProperty('accordion_target')
      ? document.querySelector(`#${accordion.dataset.accordion_target}`)
      : null;
    header.addEventListener('click', function () {
      if (accordion.classList.contains('active')) {
        if (animatingAccordion) {
          return;
        } else {
          animatingAccordion = true;
          content.classList.remove('grid-rows-[1fr]');
          content.classList.add('grid-rows-[0fr]');
          accordion.classList.remove('active');
          plusIcon.classList.remove('hidden');
          minusIcon.classList.add('hidden');
          // hide accordion image
          if (image) image.classList.remove('!opacity-100');
          setTimeout(function () {
            animatingAccordion = false;
          }, 700);
        }
      } else {
        if (animatingAccordion) {
          return;
        } else {
          animatingAccordion = true;
          // handle accordion content toggle when in group
          if (accordion.dataset.hasOwnProperty('accordion_group')) {
            const current = document.querySelector(
              `[data-accordion_group="${accordion.dataset.accordion_group}"].active`
            );
            if (current) current.querySelector('.accordion-header').click();
          }
          content.classList.remove('grid-rows-[0fr]');
          content.classList.add('grid-rows-[1fr]');
          accordion.classList.add('active');
          plusIcon.classList.add('hidden');
          minusIcon.classList.remove('hidden');
          // show accordion image
          if (image) image.classList.add('!opacity-100');
          setTimeout(function () {
            animatingAccordion = false;
          }, 700);
        }
      }
    });
    if (accordion.classList.contains('init')) header.click();
  });

  // timeline swiper scripts //
  var timelineSwiper = new Swiper('.swiper.timeline-swiper', {
    slidesPerView: 'auto',
    touchEventsTarget: 'container',
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    freeMode: {
      enabled: true,
      momentumRatio: 1,
      momentumBounce: false,
    },
    keyboard: {
      enabled: true,
    },
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
    navigation: {
      nextEl: '.timeline-button-next',
      prevEl: '.timeline-button-prev',
    },
    on: {
      click() {
        timelineSwiper.slideTo(this.clickedIndex);
      },
    },
  });

  // filter scripts //

  let filterButtons = document.querySelectorAll('.filter-button');
  let filter = document.getElementById('filter');
  let closeFilter = document.getElementById('close-filter');
  if (filterButtons.length >= 1) {
    filterButtons.forEach(function (filterButton) {
      if (filter) {
        filterButton.addEventListener('click', function () {
          filter.classList.remove('-right-96');
          filter.classList.add('right-0', 'active');
        });
      }
    });
    if (closeFilter && filter) {
      closeFilter.addEventListener('click', function () {
        filter.classList.add('-right-96');
        filter.classList.remove('right-0', 'active');
      });
    }
  }

  if (filter) {
    document.addEventListener('click', function (e) {
      if (filter.classList.contains('active')) {
        if (e.target.closest('a')) {
          filter.classList.add('-right-96');
          filter.classList.remove('right-0', 'active');
        } else if (e.target.closest('button:not(.filter-button)')) {
          filter.classList.add('-right-96');
          filter.classList.remove('right-0', 'active');
        }
      }
    });
  }

  // filter journal scripts //

  let filterJournalButtons = document.querySelectorAll('.filter-journal-button');
  let filterJournal = document.getElementById('filter-journal');
  let closeFilterJournal = document.getElementById('close-filter-journal');

  if (filterJournalButtons.length >= 1) {
    filterJournalButtons.forEach(function (filterJournalButton) {
      if (filterJournal) {
        filterJournalButton.addEventListener('click', function () {
          filterJournal.classList.remove('-right-96');
          filterJournal.classList.add('right-0', 'active');
        });
      }
    });
    if (closeFilterJournal && filterJournal) {
      closeFilterJournal.addEventListener('click', function () {
        filterJournal.classList.add('-right-96');
        filterJournal.classList.remove('right-0', 'active');
      });
    }
  }

  if (filterJournal) {
    document.addEventListener('click', function (e) {
      if (filterJournal.classList.contains('active')) {
        if (e.target.closest('a')) {
          filterJournal.classList.add('-right-96');
          filterJournal.classList.remove('right-0', 'active');
        } else if (e.target.closest('button:not(.filter-journal-button)')) {
          filterJournal.classList.add('-right-96');
          filterJournal.classList.remove('right-0', 'active');
        }
      }
    });
  }

  // nav scripts //

  let navButton = document.getElementById('nav-button');
  let nav = document.getElementById('nav');
  let navClose = document.getElementById('nav-close');

  navButton.addEventListener('click', function (e) {
    nav.classList.remove('-left-96');
    nav.classList.add('left-0', 'active');
  });
  navClose.addEventListener('click', function () {
    nav.classList.add('-left-96');
    nav.classList.remove('left-0', 'active');
  });

  document.addEventListener('click', function (e) {
    if (nav.classList.contains('active')) {
      if (e.target.closest('a')) {
        nav.classList.add('-left-96');
        nav.classList.remove('left-0', 'active');
      } else if (e.target.closest('button:not(#nav-button)')) {
        nav.classList.add('-left-96');
        nav.classList.remove('left-0', 'active');
      }
    }
  });

  // customer service scripts //

  let serviceButtons = document.querySelectorAll('.service-button');
  let serviceAside = document.getElementById('service-aside');
  let closeService = document.getElementById('close-service-aside');

  if (serviceButtons.length >= 1) {
    serviceButtons.forEach(function (serviceButton) {
      serviceButton.addEventListener('click', function (e) {
        e.preventDefault();
        serviceAside.classList.remove('-right-96');
        serviceAside.classList.add('right-0');
      });
      closeService.addEventListener('click', function () {
        serviceAside.classList.add('-right-96');
        serviceAside.classList.remove('right-0');
      });
    });
  }

  // cart scripts //

  let cartButtons = document.querySelectorAll('.cart-button');
  let cart = document.getElementById('cart');
  let closeCart = document.getElementById('close-cart');

  if (cartButtons.length >= 1) {
    cartButtons.forEach(function (cartButtons) {
      cartButtons.addEventListener('click', function (e) {
        e.preventDefault();
        cart.classList.remove('-right-96');
        cart.classList.add('right-0', 'active');
      });
    });
    if (closeCart) {
      closeCart.addEventListener('click', function () {
        cart.classList.add('-right-96');
        cart.classList.remove('right-0', 'active');
      });
    }
  }

  /* 
  ? definir cual es el comportamiento esperado
  document.addEventListener('click', function (e) {
    if (cart.classList.contains('active')) {
      if (e.target.closest('a')) {
        cart.classList.add('-right-96');
        cart.classList.remove('right-0', 'active');
      } else if (e.target.closest('button:not(.cart-button)')) {
        cart.classList.add('-right-96');
        cart.classList.remove('right-0', 'active');
      }
    }
  }); */

  // custom selects //

  let customSelects = document.querySelectorAll('.custom-select');
  if (customSelects.length >= 1) {
    customSelects.forEach(function (customSelect) {
      let customSelectHeader = customSelect.querySelector('.custom-select-header');
      let customSelectOptions = customSelect.querySelector('.custom-select-options');
      let customSelectPlusIcon = customSelect.querySelector('.custom-select-plus-icon');
      let customSelectMinusIcon = customSelect.querySelector('.custom-select-minus-icon');

      customSelectHeader.addEventListener('click', function () {
        if (customSelect.classList.contains('active')) {
          closeSelect();
        } else {
          openSelect();
        }
      });

      document.querySelector('body').addEventListener('click', function (event) {
        if (event.target === customSelect || event.target === customSelectHeader) {
          return;
        } else {
          closeSelect();
        }
      });

      function openSelect() {
        customSelect.classList.add('active');
        customSelectOptions.classList.remove('hidden');
        customSelectPlusIcon.classList.add('hidden');
        customSelectMinusIcon.classList.remove('hidden');
      }
      function closeSelect() {
        customSelect.classList.remove('active');
        customSelectOptions.classList.add('hidden');
        customSelectPlusIcon.classList.remove('hidden');
        customSelectMinusIcon.classList.add('hidden');
      }

      let options = customSelectOptions.querySelectorAll('.option');

      options.forEach(function (option) {
        let value = option.textContent;
        option.addEventListener('click', function () {
          customSelectHeader.textContent = value;
          closeSelect();
        });
      });
    });
  }

  // collaborators //

  let collaborators = document.querySelectorAll('.collaborator');

  if (collaborators.length >= 1) {
    let backdrop = document.getElementById('collaborator-backdrop');
    collaborators.forEach(function (collaborator) {
      let name = collaborator.querySelector('.collaborator-name');
      let info = collaborator.querySelector('.collaborator-info');
      let close = collaborator.querySelector('.close-collaborator-modal');
      name.addEventListener('click', function () {
        if (collaborator.classList.contains('active')) return;
        close.classList.remove('hidden');
        collaborator.classList.add('active', 'z-[15]');
        name.classList.add('underline');
        // dynamically set collaborator info top settings
        info.style.top = `${name.offsetHeight}px`;
        info.classList.remove('hidden');
        backdrop.classList.remove('hidden');
      });
      close.addEventListener('click', function () {
        if (!collaborator.classList.contains('active')) return;
        close.classList.add('hidden');
        collaborator.classList.remove('active', 'z-[15]');
        name.classList.remove('underline');
        info.classList.add('hidden');
        backdrop.classList.add('hidden');
      });
    });
    // handle backdrop click when a collaborator card is active
    backdrop.addEventListener('click', () => {
      if (backdrop.classList.contains('hidden')) return;
      const activeCollaborator = document.querySelector('.collaborator.active');
      if (!activeCollaborator) return;
      activeCollaborator.querySelector('.close-collaborator-modal').click();
    });
  }

  // journal swiper scripts //

  let journalSwiper = new Swiper('.swiper.journal-swiper', {
    slidesPerView: 1,
    centeredSlides: true,
    autoHeight: true,
    loop: true,
    navigation: {
      nextEl: '.journal-swiper-button-next',
      prevEl: '.journal-swiper-button-prev',
    },
  });

  // slideshow swiper scripts //

  let slideshowSwiper = new Swiper('.swiper.slideshow-swiper', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    navigation: {
      nextEl: '.slideshow-swiper-button-next',
      prevEl: '.slideshow-swiper-button-prev',
    },
  });

  // anchor tags smooth scrolling //

  const triggerAnchors = document.querySelectorAll('a[data-scroll]');
  triggerAnchors.forEach((anchor) => anchor.addEventListener('click', smoothScrollAnchorTarget));

  function smoothScrollAnchorTarget(event) {
    event.preventDefault();
    const target = document.querySelector(this.dataset.scroll);
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth' });
    const observer = new IntersectionObserver(trackAnchorTargetScroll, { threshold: 0.1 });
    observer.observe(target);
  }

  function trackAnchorTargetScroll(entries, observer) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const target = entry.target;
      /* target.setAttribute('tabindex', '-1');
      target.focus(); */
      observer.unobserve(target);
    });
  }
});
